<template>
    <div class="sm:items-start mt-4">
        <span class="block text-lg font-medium text-zinc-800 sm:mt-2 sm:pt-2">
            Grade Levels Taught 
        </span>
        <div class="mt-2">
            <fieldset class="flex">
                <legend class="sr-only text-black">
                    <span class="">
                        Grades
                    </span>
                </legend>
                <div class="space-x-4">
                    <label v-for="gradeBand in allGradeBands" :key="gradeBand.value" class="font-medium text-gray-700 text-lg pb-2 inline-block ml-1">
                        <input v-model="gradeBands" :value="gradeBand.value" type="checkbox"
                            class="focus:ring-[#546FA3] h-4 w-4 text-[#546FA3] border-[#49454F] align-middle rounded-sm">
                        <span class="ml-2 align-middle">{{ gradeBand.label }}</span>
                    </label>
                </div>
            </fieldset>
        </div>
    </div>
</template>

<script>
const allGradeBands = [
    {label : 'K-2', value : 'k-2'},
    {label : '3-5', value : '3-5'},
    {label : '6-8', value : '6-8'},
    {label : '9-12', value : '9-12'},
    {label : 'AP® / College', value : 'ap-college'},
];
export default {
    props:{
        modelValue: Array
    },
    data(){
        return {
            allGradeBands,
        }
    },
    computed:{
        gradeBands:{
            get(){
                return this.modelValue
            },
            set(value){
                this.$emit('update:modelValue', value)
            }  
        }
        
    }
}
</script>